const state = {
    user: null,
    URL_AUTH_ME: '/api/v1/auth/me',
}

const getters = {
    check: state => !! state.user,
    username: state => state.user ? state.user.name : ''
}

const mutations = {
    setUser (state, user) {
        if (user && user.level) {
            state.user = Object.assign({}, user)
        } else {
            state.user = null
            db.removeToken()
        }
    }
}

const actions = {
    async ready (context, data) {
        return axios
            .post('/api/v1/auth/ready', data)
            .then((response) => {
                return response
            })
            .catch((error) => {
                return Promise.reject(error.response.data.errors || {})
            })
    },
    async login (context, data) {
        return axios
            .post('/api/v1/auth/login', data)
            .then(async (response) => {
//                await db.setToken(response.data.data.token)
                await this.dispatch('auth/me')
                return response
            })
            .catch((error) => {
                return Promise.reject(error.response.data.errors || {})
            })
    },
    async logout (context, data) {
        return axios
            .get('/api/v1/auth/logout')
            .then(async (response) => {
                await this.dispatch('auth/me')
                return response
            })
            .catch(async (error) => {
                await this.dispatch('auth/me')
                return Promise.reject(error.response.data.errors || {})
            })
    },
    async me (context, data = {}) {
//        let token = null
//        await db.getToken().then(token_db => {
//            token = token_db
//        })
//        if (! token) {
//            context.commit('setUser', null)
//            return
//        }

        const response = await axios
            .get(context.state.URL_AUTH_ME, {
                params: {
                    SILENT: data.SILENT || false,
                },
            })
            .catch(error => {
                if (!error.response) {
                    // no internet
                    return false
                }

                return error.response || null
            })

        if (response === false) {
            return null
        }
        if (response.status >= 500) {
            return null
        }

        context.commit('setUser', response ? response.data.data : null)

        return response
    },
    async settings (context, data) {
        return axios
            .post('/api/v1/auth/settings', data)
            .then((response) => {
                return response
            })
            .catch((error) => {
                return Promise.reject(error.response.data.errors || {})
            })
    },
    async email (context, data) {
        return axios
            .post('/api/v1/auth/email', data)
            .then((response) => {
                return response
            })
            .catch((error) => {
                return Promise.reject(error.response.data.errors || {})
            })
    },
    async redirect (context, provider) {
        return axios
            .get('/api/v1/auth/redirect/' + provider)
            .then((response) => {
                location.href = response.data.data.url
            })
            .catch((error) => {
                return Promise.reject(error.response.data.errors || {})
            })
    },
    async disconnect (context, provider) {
        return axios
            .post('/api/v1/auth/disconnect/' + provider)
            .then((response) => {
                return response
            })
            .catch((error) => {
                return Promise.reject(error.response.data.errors || {})
            })
    },













    







}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}

